export default {"src":"/_next/static/media/sber.33083577.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};